<template>
  <div class="content"
       @click="xmboxIndex = -1">
    <header_index></header_index>
    <div class="top">
      <!-- <div class="top"> -->
      <img class="banner"
           :src="banner"
           alt="" />
      <!-- <div class="topf"
           :style="'background: url('+banner+');'"> -->
      <div class="topbox EC_width">
        <div class="topEnter"
             @click="toEnter">
          <img src="../../assets/img/icon/fangzi.png"
               alt="" />
          <span>机构入驻申请</span>
          <div></div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div class="boxTitle EC_width"
         v-show="tuwenList.length > 0 || shipinInfo">
      <!-- <span>{{ info.org_name }}</span> -->
      <span>基本信息</span>
    </div>
    <div class="top1 EC_width"
         :style="isNokc ? 'margin-bottom:30px' : ''"
         v-show="tuwenList.length > 0 || shipinInfo">
      <div class="top1left">
        <div class="t1limg"
             v-show="top1left == 1"
             v-if="tuwenList[Math.abs(tuwenIndex % tuwenList.length)]">
          <el-image :src="tuwenList[Math.abs(tuwenIndex % tuwenList.length)].resUrl"
                    class="t1limgbox">
            <div slot="placeholder"
                 class="image-slot">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
          <div class="t1limgList">
            <div class="imgListLeft"
                 :style="5 < tuwenList.length ? 'background: #0b8586;cursor: pointer;' : ''"
                 @click="5 < tuwenList.length ? tuwenIndex-- : ''">
              <img src="../../assets/img/icon/小于号.png"
                   alt="" />
            </div>
            <div class="imgListBox">
              <img v-for="(item, index) in tuwenList2"
                   :style="index == 0 ? 'margin-left: 0px;' : ''"
                   :key="index"
                   :src="item.resUrl"
                   @click="tuwenList.length > 5 ? (tuwenIndex = tuwenIndex + index) : (tuwenIndex = 0 + index)"
                   alt="" />
            </div>
            <div class="imgListRight"
                 :style="5 < tuwenList.length ? 'background: #0b8586;cursor: pointer;' : ''"
                 @click="5 < tuwenList.length ? tuwenIndex++ : ''">
              <img src="../../assets/img/icon/大于号.png"
                   alt="" />
            </div>
          </div>
        </div>
        <div class="tilmp3"
             v-show="top1left == 2">
          <div id="mp3"
               style="background: #000000;"></div>
        </div>
      </div>
      <div class="top1right">
        <div class="t1rimg"
             v-if="tuwenList[Math.abs(tuwenIndex % tuwenList.length)]"
             v-show="top1left == 1">
          <div class="t1rtitle">
            <span>{{ tuwenList[Math.abs(tuwenIndex % tuwenList.length)].title }}</span>
          </div>
          <div class="t1rhengxian"></div>
          <div class="t1rneirong">
            <div v-html="tuwenList[Math.abs(tuwenIndex % tuwenList.length)].abstract"></div>
          </div>
        </div>
        <div class="tirmp3"
             v-show="top1left == 2">
          <div class="t1rtitle">
            <span>{{ shipinInfo.title }}</span>
          </div>
          <div class="t1rhengxian"></div>
          <div class="t1rneirong">
            <div v-html="shipinInfo.abstract"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="boxTitle EC_width"
         v-if="featureList.length>0&&featureShow==true">
      <span>机构特色</span>
    </div>
    <div class="display_flex EC_width feature"
         v-if="featureList.length>0&&featureShow==true">
      <div class="leftText">
        <swiper :options="swiperOption3"
                ref="mySwiper_info">
          <swiper-slide v-for="(item,index) in featureList"
                        :key="index">
            <div class="featurebox">
              <div class="fetitle">
                <span>{{item.title}}</span>
              </div>
              <div class="fecontent"
                   v-html="item.o_content"></div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination fiexdrig"
               slot="pagination"></div>
        </swiper>
      </div>
      <div class="display_center_ud featImg"
           v-if="featureList.length>featureIndex">
        <el-image :src="featureList[featureIndex].coverPicture"
                  v-if="featureList[featureIndex].o_type==1">
          <div slot="placeholder"
               class="image-slot">
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <video controls="controls"
               :poster="featureList[featureIndex].coverPicture"
               v-if="featureList[featureIndex].o_type==2"
               :src="featureList[featureIndex].res_Url"></video>
      </div>
    </div>
    <div class="boxTitle EC_width"
         v-if="elegantList.length>0&&elegantShow==true">
      <span>{{orgId==116?'包头市基层卫生工作先锋':'机构风采人物'}}</span>
    </div>
    <div class="positionBtn EC_width elegant"
         v-if="elegantList.length>0&&elegantShow==true">
      <swiper :options="swiperOption2"
              ref="mySwiper">
        <swiper-slide v-for="(item, index) in elegantList"
                      :key="index">
          <a href="javascript:0"
             style="cursor:default;"
             :title="item.title">
            <div class="fengcai">
              <el-image :src="item.coverPicture"
                        v-show="item.o_type==1"
                        fit="contain"
                        class="fcImg">
                <div slot="placeholder"
                     class="image-slot">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
              <video class="fcImg"
                     :poster="item.coverPicture"
                     controls="controls"
                     v-show="item.o_type==2"
                     :src="item.res_Url"></video>
              <div class="fcText">{{item.title}}</div>
            </div>
          </a>
        </swiper-slide>
      </swiper>
      <div class="prevbutton el-icon-arrow-left"></div>
      <div class="nextbutton  el-icon-arrow-right"></div>
    </div>
    <div class="boxTitle EC_width t3top"
         v-show="!isNokc">
      <span>机构课程</span>
      <div class="t3tbox">
        <div class="t3tbiaoqian"
             @click="t3tbiaoqian = ''"
             :style="t3tbiaoqian == '' ? 'background: #007380;color:#fff' : ''">
          全部
        </div>
        <div class="t3tbiaoqian"
             v-for="(item, index) in t3tbiaoqianList"
             :style="t3tbiaoqian == item.id ? 'background: #007380;color:#fff' : ''"
             @click="t3tbiaoqian = item.id"
             :key="index">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="t3mid EC_width"
         v-show="kechengList.length > 0">
      <div class="t3mbox"
           v-for="(item, index) in kechengList"
           :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
           @click="tokecheng(item.id)"
           :key="index">
        <el-image :src="item.acr_PictResUrl">
          <div slot="placeholder"
               class="image-slot">
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <div class="t3mboxbot">
          <span class="t3title">{{ item.title }}</span>
          <div class="t3biaoqian">
            <div v-for="(items, index) in item.labelName.split(',').slice(0, 3)"
                 :key="index + 's'"
                 :style="index == 0 ? 'margin-left:0' : ''"
                 v-show="items != ''">
              <span>{{ items }}</span>
            </div>
          </div>
          <div class="t3more">
            <span style="color:red"
                  v-show="item.discountStatus == 2">免费</span>
            <span style="color:red"
                  v-show="item.discountStatus == 1">VIP专享</span>
            <span v-show="item.discountStatus == 0">￥{{ item.price }}</span>
            <div>
              <img src="../../assets/img/icon/ren.png"
                   style="width:10px;height:11px;margin-right:10px"
                   alt="" />
              <span>{{ item.playSum }}人</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="t3bot2"
         v-show="dianList.length > 1">
      <pagination :total="kechengNum"
                  :limit="8"
                  :page="dianing"
                  @page-change="pageChange"></pagination>
    </div>
    <div class="t3mid2"
         v-show="kechengList.length == 0 && !isNokc">
      <span>没有找到符合条件的课程</span>
    </div>
    <div class="top5f"
         v-if="xiangmuList.length > 0">
      <div class="boxTitle EC_width">
        <span>机构项目</span>
      </div>
      <div class="top5 EC_width">
        <div class="xmbox">
          <div class="xiangmubox"
               v-for="(item, index) in xiangmuList.slice((xiangmuIndex - 1) * 4, xiangmuIndex * 4)"
               :key="index"
               @click.stop="xmboxIndex = item.pId"
               :style="index == 0? xmboxIndex == item.pId
                                    ? 'border: 1px solid #007380;box-shadow: 8px 13px 30px 0px rgba(0, 99, 110, 0.3);margin-left:0'
                                    : 'margin-left:0'
                                : xmboxIndex == item.pId
                                ? 'border: 1px solid #007380;box-shadow: 8px 13px 30px 0px rgba(0, 99, 110, 0.3);'
                                : ''">
            <div class="xmtitle"
                 :style="xmboxIndex == item.pId ? 'color:#007380' : ''">
              {{ item.p_Name }}
            </div>
            <div class="xmneirong">
              <p>{{ item.org_name }}</p>
              <p>
                <span>{{ item.startDate.substring(0, 10) }}</span>
                <span> — </span>
                <span>{{ item.endDate.substring(0, 10) }}</span>
              </p>
            </div>
            <div class="xmsanjiao"
                 v-show="xmboxIndex == item.pId">
              <img src="../../assets/img/icon/sanjiao.png"
                   alt="" />
            </div>
          </div>
          <div class="xmkcbox"
               @click.stop
               v-if="xmboxIndex != -1">
            <div class="xmkc"
                 v-for="(item, index) in xmkcList"
                 @click="tokecheng(item.id)"
                 :key="index">
              <span style="font-size:18px;margin-right:10px">·</span>
              <span>{{ item.title }}</span>
              <span v-for="(items, indexs) in item.labelName.split(',')"
                    :key="indexs + 's'"
                    v-show="items">【{{ items }}】</span>
            </div>
          </div>
          <div class="tbleft tbbtn"
               v-show="xiangmuList.length > 4">
            <img src="../../assets/img/icon/left.png"
                 v-show="xiangmuIndex == 1"
                 alt="" />
            <img src="../../assets/img/icon/bg-left.png"
                 style="cursor: pointer;"
                 @click="xiangmuIndex--"
                 v-show="xiangmuIndex > 1"
                 alt="" />
          </div>
          <div class="tbright tbbtn"
               v-show="xiangmuList.length > 4">
            <img src="../../assets/img/icon/right.png"
                 v-show="xiangmuIndex * 4 >= xiangmuList.length"
                 alt="" />
            <img src="../../assets/img/icon/bg-right.png"
                 style="cursor: pointer;"
                 v-show="xiangmuIndex * 4 < xiangmuList.length"
                 @click="xiangmuIndex++"
                 alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="top6t boxTitle EC_width"
         v-if="uid != 0">
      <span>我的机构课程</span>
      <div class="t6titler">
        <div class="t6titlerb"
             @click="isXuefen = 1"
             :style="isXuefen == 1 ? 'background: #0B8586;color:#fff' : ''">学分项目</div>
        <div class="t6titlerb"
             @click="isXuefen = 2"
             :style="isXuefen == 2 ? 'background: #0B8586;color:#fff' : ''">非学分项目</div>
      </div>
    </div>
    <div class="top6t2 EC_width"
         v-if="uid != 0">
      <span>{{ info.org_name }}</span>
    </div>
    <div class="top6 EC_width"
         v-if="uid != 0">
      <div class="t6xm"
           v-if="myXiangmu.length>0">
        <div class="t6xm1"
             v-show="!ist6xm">
          <div class="t6xmbox"
               v-for="(item, index) in myXiangmu.slice(0, 5)"
               :style="myXiangmuId == item.id ? 'background: linear-gradient(119deg, #008F91, #F7AE00);' : ''"
               @click="toXiangmu(item)"
               :key="index">
            <span class="t6xmtitle"
                  :style="myXiangmuId == item.id ? 'color:#fff' : ''">{{ item.p_Name }}</span>
            <div class="t6xmtime"
                 v-show="item.id>0"
                 :style="myXiangmuId == item.id ? 'color:#fff' : ''">
              <span v-if="item.startDate!=null">{{ item.startDate.substring(0, 10) }}</span>
              <span> — </span>
              <span v-if="item.endDate!=null">{{ item.endDate.substring(0, 10) }}</span>
            </div>
            <img src="../../assets/img/icon/jifen.png"
                 v-show="item.isCredit"
                 alt="" />
          </div>
        </div>
        <div class="t6xm2"
             v-show="ist6xm">
          <div class="t6xmbox"
               v-for="(item, index) in myXiangmu"
               :style="myXiangmuId == item.id ? 'background: linear-gradient(119deg, #008F91, #F7AE00);' : ''"
               @click="toXiangmu(item)"
               :key="index">
            <span class="t6xmtitle"
                  :style="myXiangmuId == item.id ? 'color:#fff' : ''">{{ item.p_Name }}</span>
            <div class="t6xmtime"
                 v-show="item.id>0"
                 :style="myXiangmuId == item.id ? 'color:#fff' : ''">
              <span v-if="item.startDate!=null">{{ item.startDate.substring(0, 10) }}</span>
              <span> — </span>
              <span v-if="item.endDate!=null">{{ item.endDate.substring(0, 10) }}</span>
            </div>
            <img src="../../assets/img/icon/jifen.png"
                 v-show="item.isCredit"
                 alt="" />
          </div>
        </div>
        <div class="t6xmshow"
             @click="ist6xm = !ist6xm">
          <span v-show="!ist6xm">更多</span>
          <span v-show="ist6xm">收起</span>
          <img src="../../assets/img/icon/gengduo.png"
               v-show="!ist6xm"
               alt="" />
          <img src="../../assets/img/icon/shouqi.png"
               v-show="ist6xm"
               alt="" />
        </div>
      </div>
      <div class="t6xian"></div>
      <!-- <div class="t6btn"
           v-show="isXuefen == 1&&myXiangmu.length>0">
        <div class="t6btnbox"
             @click="openxueji">
          学籍信息补充
        </div>
        <div class="t6btnbox"
             @click="openxuefen"
             style="background: #B70009;">
          学分查询
        </div>
        <div class="xuefenBox">
          <el-dialog :visible.sync="isxuefenBox"
                     width="440px">
            <div class="xftop">
              <img src="../../assets/img/icon/jifen.png"
                   alt="" />
              <span>学分查询</span>
            </div>
            <div class="xfmid">
              {{ creditContent }}
            </div>
          </el-dialog>
        </div>
        <div class="xuejiBox">
          <el-dialog :visible.sync="isxuejiBox"
                     width="440px">
            <div class="xftop">
              <span>学籍信息查看</span>
            </div>
            <div class="xfmid">
              <el-form label-width="73px">
                <el-form-item label="姓名:">
                  <el-input v-model="form.name"
                            placeholder="请输入姓名"
                            clearable></el-input>
                </el-form-item>
                <el-form-item label="身份证号:">
                  <el-input v-model="form.number"
                            placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="工作单位:">
                  <el-input v-model="form.unit"
                            placeholder="请输入工作单位"></el-input>
                </el-form-item>
                <el-form-item label="职称:">
                  <el-select v-model="form.position"
                             placeholder="请选择职称">
                    <el-option v-for="item in positionOptions"
                               :key="item.id"
                               :label="item.valueText"
                               :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学历:">
                  <el-select v-model="form.edu"
                             placeholder="请选择学历">
                    <el-option v-for="item in eduOptions"
                               :key="item.id"
                               :label="item.valueText"
                               :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="科室:">
                  <el-select v-model="form.department"
                             placeholder="请选择科室">
                    <el-option v-for="item in departmentOptions"
                               :key="item.id"
                               :label="item.valueText"
                               :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地区:"
                              style="height:40px;position: relative">
                  <el-cascader v-model="form.region"
                               :placeholder="region ? '' : '请选择省市区县'"
                               :options="arealist"
                               @expand-change="expandChange"></el-cascader>
                  <span style="position: absolute;top:0px;left:15px;color: #606266;"
                        v-show="form.region == ''">{{ region }}</span>
                </el-form-item>
                <div class="xuejibtn">
                  <div class="xuejibtnbox"
                       @click="postxueji"
                       style="background: #0B8586;color:#fff">
                    提交
                  </div>
                  <div class="xuejibtnbox"
                       @click="isxuejiBox = false">
                    取消
                  </div>
                </div>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </div> -->
      <div class="t6kc">
        <div class="t3mid EC_width"
             v-show="mykecheng.length > 0">
          <div class="t3mbox"
               v-for="(item, index) in mykecheng.slice(0, isgengduo ? mykecheng.length : 8)"
               :style="(index + 1) % 4 == 0 ? 'margin-right:0' : ''"
               @click="tokecheng(item.courseId)"
               :key="index">
            <el-image :src="item.coverPicture">
              <div slot="placeholder"
                   class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div class="t3mboxbot">
              <span class="t3title">{{ item.title }}</span>
              <div class="t3biaoqian">
                <span>学习进度</span>
                <div class="jindu">
                  <div class="jindubox"
                       :style="'width:' + Math.ceil(item.learning * 100) + '%'"></div>
                </div>
              </div>
              <div class="t3more">
                <div>
                  <span>已学</span>
                  <span style="color:#0b8586">{{ Math.ceil(item.learning * 100) }}%</span>
                </div>
                <div v-show="myXiangmuId>0">
                  <img src="../../assets/img/icon/ren.png"
                       style="width:10px;height:11px;margin-right:10px"
                       alt="" />
                  <span>{{ item.numberPeople }}人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="t3bot"
             v-show="mykecheng.length > 8">
          <div class="t6gengduo"
               @click="isgengduo = !isgengduo">
            <img src="../../assets/img/icon/xiangxia.png"
                 :style="isgengduo ? 'transform: rotate(180deg);' : ''"
                 alt="" />
            <span v-show="!isgengduo">更多课程</span>
            <span v-show="isgengduo">收起</span>
          </div>
        </div>
        <div class="t3mid2"
             v-show="mykecheng.length == 0">
          <span>没有找到符合条件的课程</span>
        </div>
      </div>
    </div>
    <div class="boxTitle EC_width"
         v-if="linkList.length > 0">
      <span>我的Link</span>
    </div>
    <div class="top4 EC_width"
         v-if="linkList.length > 0">
      <div class="llbox"
           v-if="linkList.length > 0">
        <div class="linkbox"
             v-for="(item, index) in linkList"
             @click="toLink(item.l_Url)"
             :key="index">
          <el-image :src="item.pictureUrl"
                    class="fengmian">
            <div slot="placeholder"
                 class="image-slot">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
          <span>{{ item.title }}</span>
        </div>
      </div>
      <div class="tbleft tbbtn"
           v-show="linktotalpage > 1">
        <img src="../../assets/img/icon/left.png"
             v-show="linkpage == 1"
             alt="" />
        <img src="../../assets/img/icon/bg-left.png"
             style="cursor: pointer;"
             @click="linkpage = linkpage - 1"
             v-show="linkpage > 1"
             alt="" />
      </div>
      <div class="tbright tbbtn"
           v-show="linktotalpage > 1">
        <img src="../../assets/img/icon/right.png"
             v-show="linkpage == linktotalpage"
             alt="" />
        <img src="../../assets/img/icon/bg-right.png"
             style="cursor: pointer;"
             v-show="linkpage < linktotalpage"
             @click="linkpage = linkpage + 1"
             alt="" />
      </div>
    </div>
    <footer_index></footer_index>
  </div>
</template>

<script>
import Player from 'xgplayer/dist/simple_player';
import { areaList } from '@vant/area-data';
import header_index from '../../components/header2';
import footer_index from './footer_index.vue';
export default {
  components: {
    header_index,
    footer_index
  },
  data () {
    return {
      uid: 0,
      banner: '',
      info: '',
      orgId: 0,
      linkList: [],
      linkpage: 1,
      linktotalpage: 1,
      kechengList: [],
      dianList: [],
      dianing: 1,
      top1left: 1,
      xiangmuList: [],
      xiangmuIndex: 1,
      xmboxIndex: -1,
      xmkcList: [],
      tuwenList: [],
      shipinInfo: '',
      tuwenIndex: 120,
      player: '',
      t3tbiaoqianList: [],
      t3tbiaoqian: '',
      isXuefen: 0,
      ist6xm: false,
      myXiangmu: [],
      myXiangmuId: 0,
      mykecheng: [],
      isgengduo: false,
      isxuefenBox: false,
      creditContent: '',
      isxuejiBox: false,
      form: {
        name: '',
        number: '',
        unit: '',
        position: '',
        edu: '',
        department: '',
        region: ''
      },
      positionOptions: [],
      eduOptions: [],
      departmentOptions: [],
      arealist: [],
      oidInfo: '',
      region: '',
      isNokc: false,
      kechengNum: 0,
      featureIndex: 0,
      swiperOption3: {
        preventLinksPropagation: true,
        loop: true, // 循环模式选项
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'stWrite',
          bulletActiveClass: 'stbulletWriteActive',
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: () => {
            let swp = this.$refs.mySwiper_info.swiper;
            if (swp != null) {
              this.featureIndex = swp.realIndex
            } else {
              if (this.tuwenList.length > 0) {
                this.featureIndex = 0;
              }
            }
          }
        }
      },
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled'
        }
      },
      featureList: [],
      elegantList: [],
      featureShow: false,
      elegantShow: false
    };
  },
  watch: {
    linkpage: function () {
      this.GetLink(this.linkpage);
    },
    dianing: function () {
      this.getKecheng();
    },
    t3tbiaoqian: function () {
      this.dianing = 1;
      this.getKecheng();
    },
    xmboxIndex: function () {
      if (this.xmboxIndex != -1) this.getxmkcList(this.xmboxIndex);
    },
    isXuefen: function () {
      this.getMyXiangmu();
    },
    myXiangmuId: function () {
      this.getMyKecheng();
    },
    tuwenIndex: function () {
      if (this.tuwenList.length < 6) return;
      if (Math.abs(this.tuwenIndex % this.tuwenList.length) < this.tuwenList.length - 6) {
        this.tuwenList2 = this.tuwenList.slice(Math.abs(this.tuwenIndex % this.tuwenList.length), Math.abs(this.tuwenIndex % this.tuwenList.length) + 6);
      } else if (Math.abs(this.tuwenIndex % this.tuwenList.length) + 6 >= this.tuwenList.length) {
        this.tuwenList2 = this.tuwenList.slice(Math.abs(this.tuwenIndex % this.tuwenList.length), this.tuwenList.length);
        this.tuwenList2 = this.tuwenList2.concat(this.tuwenList.slice(0, 6 - (this.tuwenList.length - Math.abs(this.tuwenIndex % this.tuwenList.length))));
      }
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
    }
    this.orgId = Number(this.$route.query.id)
    this.getInfo();
    this.getBanner();
    this.getShow();
    this.GetLink(1);
    this.getKecheng();
    this.gett3tbiaoqian();
    this.getXiangmu();
    this.getMyXiangmu();
    this.getMyKecheng();
    this.getOldKecheng();
    this.getFeature()
    this.getElegant()
    this.GetInfoShow()
  },
  methods: {
    toEnter () {
      window.open('/user/userOrgEnter', '_blank');
    },
    toDetail (id) {
      this.$router.push({
        path: '/expertsDetail',
        query: {
          id: id
        }
      });
    },
    pageChange (page) {
      if (page == this.dianing) return;
      this.dianing = page;
      this.getKecheng();
    },
    getBanner () {
      this.httphelper
        .get('/api/CGPEnterPriseApi/GetOrgHomeBanner', {
          OrgId: this.orgId
          //   Id: 13
        })
        .then(res => {
          if (res.code == 200) {
            this.banner = res.data;
          }
        });
    },
    getInfo () {
      this.httphelper
        .get('/api/CGPEnterPriseApi/GetGpOrganInfoById', {
          Id: this.orgId
        })
        .then(res => {
          if (res.code == 200) {
            this.info = res.data;
          }
        });
    },
    GetInfoShow () {
      this.httphelper
        .get('/api/EnterpriseApi/GetOrgConfigById', {
          orgId: this.orgId
        })
        .then(res => {
          if (res.code == 200) {
            this.elegantShow = res.data.is_OrgExpert
            this.featureShow = res.data.is_Orgfeature
          }
        });
    },
    GetLink (page) {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertLinkList', {
          Id: this.orgId,
          //   Id: 13,
          type: 2,
          IsShow: true,
          limit: 6,
          Page: page
        })
        .then(res => {
          if (res.code == 200) {
            this.linkList = res.data;
            this.linktotalpage = res.totalpage;
          }
        });
    },
    getOldKecheng () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrgCourseByIdPageList', {
          labelname: this.t3tbiaoqian.toString(),
          orgId: this.orgId,
          page: this.dianing,
          limit: 8
        })
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.length == 0) {
              this.isNokc = true;
            }
          }
        });
    },
    getKecheng () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrgCourseByIdPageList', {
          labelname: this.t3tbiaoqian.toString(),
          orgId: this.orgId,
          page: this.dianing,
          limit: 8
        })
        .then(res => {
          if (res.data.code == 200) {
            this.kechengList = res.data.data;
            this.kechengNum = res.data.totalcount;
            if (this.dianList.length != 0) {
              this.dianList = [];
            }
            for (let i = 1; i <= Math.ceil(res.data.totalcount / 8); i++) {
              this.dianList.push(i);
            }
          }
        });
    },
    getShow () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganVisitList', {
          orgId: this.orgId
        })
        .then(res => {
          if (res.data.code == 200) {
            var that = this;
            this.tuwenList = [];
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].type == 1) {
                this.tuwenList.push(res.data.data[i]);
              } else if (res.data.data[i].type == 2) {
                this.shipinInfo = res.data.data[i];
                this.top1left = 2;
                this.player = new Player({
                  id: 'mp3',
                  url: this.shipinInfo.resUrl,
                  width: 670,
                  height: 440,
                  poster: this.shipinInfo.coverPictureUrl
                });
                that.player.on('ended', function () {
                  //   that.player = ''
                  //   that.player.reload()
                  that.player.destroy(true);
                  that.getShow();
                });
              }
            }
            this.tuwenList2 = this.tuwenList.slice(0, 6);
          }
        });
    },
    gett3tbiaoqian () {
      this.httphelper
        .get('/api/CGPEnterPriseApi/GetOrgCourseLabel', {
          count: 5,
          oid: this.orgId
        })
        .then(res => {
          if (res.code == 200) {
            this.t3tbiaoqianList = res.data;
          }
        });
    },
    getXiangmu () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganProjectList', {
          orgId: this.orgId
        })
        .then(res => {
          if (res.data.code == 200) {
            this.xiangmuList = res.data.data.projectList;
          }
        });
    },
    getxmkcList (id) {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganCourseList', {
          oid: this.orgId,
          pgid: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.xmkcList = res.data.data;
          }
        });
    },
    getMyXiangmu () {
      this.httphelper
        .get('/api/CourseClassApi/GetOrgProgectList', {
          UserId: Number(this.uid),
          OrgId: this.orgId,
          Type: this.isXuefen
        })
        .then(res => {
          if (res.code == 200) {
            this.myXiangmu = res.data;
            if (res.data.length > 0) {
              this.myXiangmuId = res.data[0].id;
              this.creditContent = res.data[0].creditContent;
            } else {
              this.myXiangmuId = 0;
              this.creditContent = '';
            }
          }
        });
    },
    getMyKecheng () {
      if (this.myXiangmuId == -1) {
        this.httphelper.get('/api/EnterpriseApi/GetIntCourseSchedList', {
          orgId: this.orgId,
          userId: Number(this.uid)
        })
          .then(res => {
            if (res.code == 200) {
              this.mykecheng = res.data
            }
          });
      } else if (this.myXiangmuId == -2) {
        this.httphelper.get('/api/CourseClassApi/GetUserLearprojPageList', {
          orgId: this.orgId,
          userId: Number(this.uid),
          limit: 99
        })
          .then(res => {
            if (res.code == 200) {
              this.mykecheng = []
              for (let i = 0; i < res.data.length; i++) {
                this.mykecheng.push({
                  coverPicture: res.data[i].pictureUrl,
                  learning: res.data[i].studyTime / res.data[i].length,
                  title: res.data[i].pname,
                  courseId: res.data[i].cid
                })
              }
            }
          });
      } else {
        this.httphelper.get('/api/CourseClassApi/GetProgectCourseList', {
          UserId: Number(this.uid),
          ProId: this.myXiangmuId,
        })
          .then(res => {
            if (res.code == 200) {
              this.mykecheng = res.data
            }
          });
      }
    },
    tokecheng (id) {
      if (this.myXiangmuId == -1) {
        let { href } = this.$router.resolve({
          path: '/course',
          query: {
            cid: id,
            orgid: this.orgId
          }
        });
        window.open(href, '_blank');
      } else if (this.myXiangmuId == -2) {
        if (this.$cookies.get('token_chinagp')) {
          window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + id + '&token=' + this.$cookies.get('token_chinagp'), "_blank")
        } else {
          window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + id, "_blank")
        }
      } else {
        if (this.$cookies.get('token_chinagp')) {
          window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id + '&token=' + this.$cookies.get('token_chinagp'), "_blank")
        } else {
          window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id, "_blank")
        }
      }
    },
    openxuefen () {
      this.isxuefenBox = true;
    },
    openxueji () {
      for (let i = 1; i < 7; i++) {
        this.httphelper
          .get('/api/BasicsmesApi/GetCodeResultList', {
            type: i
          })
          .then(res => {
            if (res.code == 200) {
              if (i == 2) this.positionOptions = res.data;
              else if (i == 1) this.eduOptions = res.data;
              else if (i == 3) this.departmentOptions = res.data;
            }
          });
      }
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        });
      }
      this.GetMyInfo();
      this.isxuejiBox = true;
    },
    expandChange (val) {
      if (val.length == 1) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            this.arealist[i].children = [];
          }
        }
        for (let b in areaList.city_list) {
          if (b.substr(0, 2) == val[0].substr(0, 2)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                this.arealist[i].children.push({
                  value: b,
                  label: areaList.city_list[b],
                  children: []
                });
              }
            }
          }
        }
      } else if (val.length == 2) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            for (let a = 0; a < this.arealist[i].children.length; a++) {
              if (this.arealist[i].children[a].value == val[1]) {
                this.arealist[i].children[a].children = [];
              }
            }
          }
        }
        for (let b in areaList.county_list) {
          if (b.substr(0, 4) == val[1].substr(0, 4)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                for (let a = 0; a < this.arealist[i].children.length; a++) {
                  this.arealist[i].children[a].children.push({
                    value: b,
                    label: areaList.county_list[b]
                  });
                }
              }
            }
          }
        }
      }
    },
    GetMyInfo () {
      this.httphelper
        .post('/api/CGpUserApi/GetUserMessage', {
          id: this.uid
        })
        .then(res => {
          if (res.data.data) {
            this.form.name = res.data.data.userName;
            this.form.number = res.data.data.iDcard;
            this.form.unit = res.data.data.unit;
            this.form.position = res.data.data.professionalId;
            this.form.edu = res.data.data.educatId;
            this.form.department = res.data.data.admoffId;
            this.oidInfo = res.data.data;
            for (let a in areaList.province_list) {
              if (a == res.data.data.province) {
                this.region = areaList.province_list[a];
              }
            }
            for (let a in areaList.city_list) {
              if (a == res.data.data.city) {
                this.region = this.region + ' / ' + areaList.city_list[a];
              }
            }
            for (let a in areaList.county_list) {
              if (a == res.data.data.district) {
                this.region = this.region + ' / ' + areaList.county_list[a];
              }
            }
          }
        });
    },
    postxueji () {
      this.httphelper
        .post('/api/CGpUserApi/UpdUserCredit', {
          userId: Number(this.uid),
          userName: this.form.name,
          unit: this.form.unit,
          iDcard: this.form.number,
          province: this.form.region[0] ? this.form.region[0] : this.oidInfo.province,
          city: this.form.region[1] ? this.form.region[1] : this.oidInfo.city,
          district: this.form.region[2] ? this.form.region[2] : this.oidInfo.district,
          professionalId: Number(this.form.position),
          educatId: Number(this.form.edu),
          admoffId: Number(this.form.department)
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('提交成功');
            this.isxuejiBox = false;
          } else {
            this.$message.error('提交失败');
          }
        });
    },
    toXiangmu (item) {
      this.myXiangmuId = item.id;
      this.creditContent = item.creditContent;
    },
    getFeature () {
      this.httphelper
        .get('/api/EnterpriseApi/GetWebOrgfeatureList', {
          OrgId: this.orgId
        })
        .then(res => {
          if (res.code == 200) {
            this.featureList = res.data;
          }
        });
    },
    getElegant () {
      this.httphelper
        .post('/api/EnterpriseApi/GetWebOrgExpertPageList', {
          OrgId: this.orgId,
          page: 1,
          limit: 999
        })
        .then(res => {
          if (res.data.code == 200) {
            this.elegantList = res.data.data;
          }
        });
    },
    toLink (url) {
      window.open(url, "_blank")
    }
  }
};
</script>

<style scoped>
.content {
    min-height: 650px;
}
.top {
    width: 100%;
    height: 300px;
    min-width: 1240px;
    position: relative;
    display: flex;
    justify-content: center;
    overflow: hidden;
    /* background: url('../../assets/img/organ/banner.jpg'); */
}
.banner {
    width: 1920px;
    max-width: 1920px;
    height: 300px;
    overflow: hidden;
    position: absolute;
}
.topbox {
    height: 300px;
    position: relative;
}
.topEnter {
    width: 284px;
    height: 200px;
    background: #0b8586;
    opacity: 0.95;
    border-radius: 10px 10px 0px 0px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    box-sizing: border-box;
    cursor: pointer;
}
.topEnter img {
    margin-top: 26px;
}
.topEnter span {
    margin-top: 16px;
}
.topEnter div {
    width: 43px;
    height: 1px;
    background: #ffffff;
    margin-top: 22px;
}
.boxTitle {
    height: 60px;
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    border-bottom: 1px solid #eee;
    margin-top: 40px;
}
.boxTitle span {
    border-left: 3px solid #0b8586;
    padding-left: 10px;
}
.top4 {
    position: relative;
    padding-bottom: 30px;
    height: 125px;
    margin-top: 30px;
}
.top4 .llbox {
    display: flex;
}
.top4 .linkbox {
    width: 206px;
    height: 115px;
    box-sizing: border-box;
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.top4 .linkbox .el-image {
    width: 70px;
    height: 70px;
    border-radius: 10px;
}
.top4 .tbbtn {
    position: absolute;
    bottom: 70px;
}
.top4 .tbleft {
    left: -57px;
}
.top4 .tbright {
    right: -57px;
}
.top4 .tbbtn img {
    width: 37px;
    height: 37px;
}
.top5f {
    background: #f6f7fb;
    margin-top: 40px;
    padding-top: 1px;
}
.t3top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
}
.t3ttitle {
    margin-left: 0 !important;
}
.t3mid {
    display: flex;
    flex-wrap: wrap;
}
.t3mbox {
    height: 288px;
    width: 280px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-right: 40px;
    margin-bottom: 30px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 5px 5px;
    cursor: pointer;
}
.t3mbox .el-image {
    height: 158px;
    width: 280px;
    overflow: visible;
}
.t3mboxbot {
    padding: 15px 15px 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
}
.t3title {
    width: 100%;
    height: 38px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.t3more {
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #919ca3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t3biaoqian {
    display: flex;
    flex-wrap: wrap;
}
.t3biaoqian div {
    background: #ffffff;
    border: 1px solid #979fa6;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #979fa6;
    padding: 0px 3px;
    /* margin-left: 3px; */
    margin-right: 3px;
    margin-top: 1px;
    margin-bottom: 1px;
}
.t3biaoqian span {
    white-space: nowrap;
}
.t3bot {
    display: flex;
    align-items: center;
    justify-content: center;
}
.t3bot .dian {
    width: 20px;
    height: 20px;
    border: 2px solid #cfcfcf;
    border-radius: 50%;
    margin: 10px 5px 0;
    cursor: pointer;
    box-sizing: border-box;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    color: #acacac;
    display: flex;
    justify-content: center;
    align-items: center;
}
.t3bot2 ::v-deep.pagination_Wrap {
    margin-top: 0px;
    margin-bottom: 30px;
}
.t3bot2 ::v-deep.pagination_Wrap a {
    border-radius: 10px;
    padding: 6px 10px;
    font-size: 14px;
}
.t3bot2 ::v-deep.pagination_Wrap .pwfirst {
    display: none;
}
.t3bot2 ::v-deep.pagination_Wrap .pwlast {
    display: none;
}
.t3bot2 ::v-deep.pagination_Wrap .pwtype1 {
    display: none;
}
.t3bot2 ::v-deep.pagination_Wrap .pwtype2 {
    display: block;
}
.t3mid2 {
    width: 100%;
    text-align: center;
    line-height: 100px;
}
.top1 {
    margin-top: 20px;
    height: 440px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.top1left {
    width: 670px;
    height: 440px;
    /* background: yellow; */
    position: relative;
}
.top1right {
    flex: 1;
    box-sizing: border-box;
    padding-left: 64px;
    margin: 40px 0;
    height: 360px;
}
.t1rhengxian {
    width: 50px;
    height: 1px;
    background-color: #0b8586;
    margin: 15px 0 20px;
}
.t1rtitle {
    font-size: 21px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 30px;
}
.t1rneirong {
    /* font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400; */
    height: 294px;
    /* text-align: justify; */
    padding-right: 20px;
    /* color: #000000;
    line-height: 28px;
    text-indent: 28px; */
    overflow-y: auto;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.t1rneirong::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.t1rneirong::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.t1rneirong::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #eee;
    border-radius: 6px;
}
.t1lbtn {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    z-index: 299;
}
.t1lbtn img {
    width: 18px;
    height: 18px;
}
.t1lbtnBox {
    width: 40px;
    height: 40px;
    display: inline-block;
    background: #000000;
    opacity: 0.4;
    margin-right: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.t1limg {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
}
.t1limgbox {
    width: 670px;
    height: 378px;
}
.t1limgList {
    width: 670px;
    height: 54px;
    display: flex;
    justify-content: space-between;
}
.t1limgList .imgListLeft,
.t1limgList .imgListRight {
    width: 16px;
    height: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #b3b3b3;
    color: #fff;
}
.t1limgList .imgListBox {
    width: 622px;
    height: 54px;
    display: flex;
    cursor: pointer;
}
.t1limgList .imgListBox img {
    width: 97px;
    height: 54px;
    margin-left: 8px;
}
.t3tbox {
    display: flex;
}
.t3tbiaoqian {
    height: 35px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 34px;
    padding: 0 25px;
    box-sizing: border-box;
    margin-left: 10px;
    cursor: pointer;
}
.top5 .xmbox {
    padding: 25px 0 80px;
    height: 190px;
    display: flex;
    position: relative;
}
.top5 .xiangmubox {
    width: 295px;
    height: 190px;
    background: #ffffff;
    border: 1px solid #f1f1f1;
    box-shadow: 10px 17px 30px 0px rgba(2, 29, 109, 0.1);
    margin-left: 20px;
    padding: 35px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
}
.top5 .tbbtn {
    position: absolute;
    bottom: 150px;
}
.top5 .tbleft {
    left: -57px;
}
.top5 .tbright {
    right: -57px;
}
.top5 .tbbtn img {
    width: 37px;
    height: 37px;
}
.top5 .xmtitle {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.top5 .xmsanjiao {
    position: absolute;
    top: 190px;
    left: 137px;
}
.top5 .xmneirong {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
}
.top5 .xmkcbox {
    width: 1240px;
    height: 207px;
    background: #ffffff;
    border: 1px solid #f1f1f1;
    box-shadow: 10px 17px 30px 0px rgba(2, 29, 109, 0.1);
    position: absolute;
    top: 233px;
    left: 0;
    padding: 35px;
    padding-right: 0;
    box-sizing: border-box;
    justify-content: flex-start;
    align-content: flex-start;
    display: flex;
    flex-wrap: wrap;
    z-index: 200;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.top5 .xmkcbox::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.top5 .xmkcbox::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.top5 .xmkcbox::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: rgb(255, 255, 255);
    border-radius: 6px;
}
.top5 .xmkc {
    width: 584px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*不换行*/
    text-overflow: ellipsis; /*超出部分文字以...显示*/
    cursor: pointer;
}
.top5 .xmkc:hover {
    color: #0b8586;
}
.top6t {
    display: flex;
    justify-content: space-between;
}
.top6t .t6titler {
    display: flex;
}
.top6t .t6titlerb {
    height: 36px;
    background: #ffffff;
    border: 1px solid #d5d5d5;
    border-radius: 3px;
    margin-left: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 36px;
    padding: 0 10px;
    cursor: pointer;
}
.top6t2 {
    margin-top: 15px;
    margin-bottom: 15px;
    height: 16px;
    padding-left: 10px;
    border-left: 2px solid #0b8586;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 16px;
}
.top6 {
    margin-bottom: 20px;
}
.top6 .t6xm {
    position: relative;
}
.top6 .t6xmbox {
    width: 218px;
    height: 88px;
    background: #ffffff;
    border: 1px solid #0b8586;
    box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    position: relative;
    margin-right: 10px;
    padding: 13px 18px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
}
.top6 .t6xmbox img {
    bottom: 13px;
    right: 15px;
    position: absolute;
}
.top6 .t6xmtitle {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.top6 .t6xmtime {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9f9f9f;
}
.top6 .t6xmshow {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.top6 .t6xmshow img {
    margin-left: 5px;
}
.top6 .t6xm1 {
    display: flex;
}
.top6 .t6xm2 .t6xmbox {
    margin-bottom: 10px;
}
.top6 .t6xm2 {
    display: flex;
    flex-wrap: wrap;
    min-height: 98px;
    max-height: 196px;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.top6 .t6xm2::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.top6 .t6xm2::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.top6 .t6xm2::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: rgb(241, 241, 241);
    border-radius: 6px;
}
.top6 .t6xian {
    width: 1200px;
    height: 1px;
    margin: 15px 0;
    background-color: #eee;
}
.top6 .t6btn {
    margin-bottom: 30px;
    display: flex;
}
.top6 .t6btnbox {
    width: 201px;
    height: 32px;
    background: #0b8586;
    border-radius: 15px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    cursor: pointer;
}
.top6 .t6gengduo {
    width: 240px;
    height: 33px;
    background: #0b8586;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.top6 .t6gengduo img {
    margin-right: 10px;
}
.top6 .jindu {
    width: 186px;
    height: 4px;
    background: #e5e5e5;
    border-radius: 2px;
    border: none;
    padding: 0 !important;
    margin: 0;
    margin-left: 8px;
}
.top6 .jindubox {
    width: 106px;
    height: 4px;
    background: #0b8586;
    border-radius: 2px;
    border: none;
    padding: 0 !important;
    margin: 0 !important;
}
.top6 .t3biaoqian {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.xuefenBox ::v-deep .el-dialog__body {
    padding: 10px 35px 40px;
}
.xftop {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}
.xftop img {
    margin-right: 10px;
    width: 22px;
    height: 22px;
}
.xfmid {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
}
.xuejiBox ::v-deep .el-dialog__body {
    padding: 10px 35px 40px;
}
.xuejiBox ::v-deep .el-input__inner {
    height: 35px;
    width: 297px;
}
.xuejiBox ::v-deep .el-form-item {
    margin-bottom: 10px;
}
.xuejibtn {
    display: flex;
    justify-content: center;
    margin-top: 18px;
}
.xuejibtnbox {
    width: 130px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #b6b6b6;
    border-radius: 16px;
    margin: 0 5px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1240px;
    margin-bottom: 20px;
}
/* 轮播按钮 */
.nextbutton,
.prevbutton {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 42%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}

.nextbutton {
    right: -30px;
    left: auto;
}

.prevbutton {
    right: auto;
    left: -30px;
}
.my-button-disabled {
    background: #ddd;
    color: #999;
}
.fengcai {
    width: 280px;
    height: 215px;
}
.fcText {
    height: 46px;
    line-height: 22px;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-align: center;
}
.fcImg {
    width: 280px;
    height: 160px;
    margin-bottom: 5px;
}
.elegant ::v-deep .swiper-slide {
    display: flex;
    justify-content: center;
}
.feature {
    margin-top: 20px;
}
/* .feature ::v-deep .swiper-slide {
    width: 600px !important;
} */
.feature .leftText {
    width: 643px;
    margin-right: 46px;
    /* padding-top: 20px; */
    /* padding-bottom: 20px; */
}
.featImg .el-image {
    width: 547px;
    height: 302px;
}
.featImg video {
    width: 547px;
    height: 302px;
}
.featurebox {
    height: 302px;
}
.featurebox .fetitle {
    height: 30px;
    line-height: 30px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    text-align: center;
    color: #000000;
    margin-bottom: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fiexdrig {
    z-index: 10000;
}
</style>
